// extracted by mini-css-extract-plugin
module.exports = {"progress-graph":"oJ4Qe","info":"FdTWP","label":"adxXu","progress":"t21tZ","percentage":"lqugr","value":"ELhs1"};